exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._8AmtV{border:none;margin-top:20px;padding:10px 0 0;border-top:1px solid #c8c8c8;margin:30px auto 20px}._2k4Wx{text-align:left}", ""]);

// exports
exports.locals = {
	"referenceTitle": "_8AmtV",
	"referenceList": "_2k4Wx"
};